import axiosInstance from "../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";

const headers = {
  accept: "*/*",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};

export const fetchCustomers = async () => {
  return await axiosInstance.get("customer", { headers });
};

export const getCustomerById = async (id) => {
  return await axiosInstance.get(`customer/${id}`, { headers });
};

export const blockCustomer = async (id) => {
  return await await axiosInstance.patch(`customer-login/${id}/block`, {
    headers,
  });
};

export const unBlockCustomer = async (id) => {
  return await await axiosInstance.patch(`customer-login/${id}/unblock`, {
    headers,
  });
};

export const deleteCustomer = async (id) => {
  return await axiosInstance.delete(`customer/${id}`, { headers });
};
